var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroSportsDataClean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 549 610",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lines",
    x1: 430,
    y1: 170,
    x2: 71,
    y2: 542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D9BFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4D9BFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9BFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodes",
    x1: 0,
    y1: 0,
    x2: 549,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168BFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("marker", {
    id: "line-endpoint",
    markerWidth: 5,
    markerHeight: 5,
    refX: 2.5,
    refY: 2.5,
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.6,
    fill: "#168BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h549v250h-5v12h-11v13h-11v13h-12v13h-12v13h-12v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13h-12v13h-12v13h-12v13h-13v13H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shape)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "url(#lines)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22 275 78 219l23 126 44 27 27-88 51 5 29-33 1 129 83-154 26 117 47-15 18-133 25 98 21-83 20 31 16-81 17 82 17-43 16 67 13-49",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-17 318 27 58 41 78 49-109 44 27 28 51 24-36 26 67 26-127 28 40 29-25 35 45 19-104 18 81 26-39 26 11 25-35 24 31 22-46 21 43 19-70 18 77 17-29 19 44 14-63",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-8 501 59-47 31 30 62-112 52 15 56 67 34-51 43 15 41-81 33 31 35-65 25 46 31-36 28 29 25-47 26 38 22-54 20 64 18-42",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-7 544 62-54 15-36 12 100 39-70 42-61 33 69 33-73 34 43 30-44 34 20 28-84 31 53 30-24 26 35 23-62 26 46 22-59 20 67 20-44",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 264 78 219l74 65 70 5 114-58 26-52 15 118 35-65 25 62 25-37 23 47 22-74 20 70 19-58 17 76 17-43 16 58",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 479 55 11 45-145 44 27 28 51 51-96 29 127 84-223 26 117 47-15 18-133 25 98 21-83 20 31 16-81 17 82",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 516 82-32 62 16 52-113 56 67 34-51 43 15 41-81 33 31 35-65 25 46 31-36 28 29 25-47 26 38 22-54",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#nodes)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 376,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 219,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 345,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 454,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 484,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 372,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 284,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 327,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 387,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 289,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 256,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 283,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 267,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 231,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 179,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 199,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 231,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 215,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 237,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 200,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 195,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 159,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 158,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 205,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 490,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 554,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 408,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 445,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 423,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 465,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 492,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 461,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 393,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 377,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 419,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 301,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 291,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 290,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 277,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 282,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 270,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 257,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 246,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 238,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487,
    cy: 229,
    r: 0.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#lines)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407 313 440 342 470 325 495 355 462 377 430 370 447 402 483 396 516 374 520 364",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 342 22 35 21 19",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470 325 13 71 33-22",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495 355 21 19 4-10",
    markerStart: "url(#line-endpoint)",
    markerMid: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462 377 58-13",
    markerStart: "url(#line-endpoint)",
    markerEnd: "url(#line-endpoint)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#nodes)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-1",
    cx: 407,
    cy: 313,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-2",
    cx: 440,
    cy: 342,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-3",
    cx: 470,
    cy: 325,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-4",
    cx: 495,
    cy: 355,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-5",
    cx: 462,
    cy: 377,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-6",
    cx: 430,
    cy: 370,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-7",
    cx: 447,
    cy: 402,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-8",
    cx: 483,
    cy: 396,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-9",
    cx: 516,
    cy: 374,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "case-study-field-node-10",
    cx: 520,
    cy: 364,
    r: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSportsDataClean);
export default __webpack_public_path__ + "static/media/hero-sports-data-clean.4a1ab180f7d1e942c1363e1d18275478.svg";
export { ForwardRef as ReactComponent };